import {
  FaPhoneAlt,
  FaEnvelope,
  FaTiktok,
  FaWhatsapp,
  FaFacebookF,
} from "react-icons/fa";
import { GoLocation } from "react-icons/go";

const Contact = () => {
  return (
    <section
      id="contact"
      className="bg-[#f7f0ff] text-gray-800 py-12 px-5 md:px-20"
    >
      {/* Title Section */}
      <div className="mb-12 text-center">
        <h2 className="text-4xl font-extrabold text-gray-800 mb-4 tracking-tight">
          Contact Us
        </h2>

        <p className="text-sm text-gray-500">
          Home &gt;{" "}
          <span className="text-[#7b2cbf] font-bold">Contact Us</span>
        </p>
      </div>

      {/* Contact Card */}
      <div className="w-full bg-gradient-to-r from-[#6f249f] via-[#7b2cbf] to-[#55d286] text-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 p-8 md:p-10 lg:p-14">
          {/* Left Side */}
          <div className="flex flex-col justify-center">
            <h3 className="text-3xl lg:text-4xl font-bold mb-6">
              Let&apos;s Connect
            </h3>

            <p className="text-purple-100 leading-8 text-lg">
              We would love to hear from you. Whether you have questions about
              our products, need assistance with an order, want to partner with
              us, or simply need more information, our team is always available
              to help.
            </p>

            <div className="mt-8">
              <div className="inline-block bg-white/15 backdrop-blur-sm rounded-xl px-6 py-4">
                <h4 className="font-semibold text-xl mb-2">CHAREX</h4>

                <p className="text-green-200 italic">
                  Shop Smart. Save More. Smile More.
                </p>
              </div>
            </div>
          </div>

          {/* Right Side */}
          <div className="space-y-7">
            {/* Phone */}
            <div className="flex items-center">
              <div className="w-12 h-12 flex items-center justify-center bg-white/15 rounded-full mr-5 flex-shrink-0">
                <FaPhoneAlt className="text-[#55d286] text-xl" />
              </div>

              <div>
                <p className="text-sm text-purple-100 mb-1">Phone Number</p>

                <a
                  href="tel:+2347064058684"
                  className="text-lg hover:text-[#55d286] hover:underline transition-colors duration-300"
                >
                  +234 706 405 8684
                </a>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-center">
              <div className="w-12 h-12 flex items-center justify-center bg-white/15 rounded-full mr-5 flex-shrink-0">
                <FaEnvelope className="text-[#55d286] text-xl" />
              </div>

              <div className="min-w-0">
                <p className="text-sm text-purple-100 mb-1">Email Address</p>

                <a
                  href="mailto:PreorderwithCharex@gmail.com"
                  className="text-lg break-all hover:text-[#55d286] hover:underline transition-colors duration-300"
                >
                  PreorderwithCharex@gmail.com
                </a>
              </div>
            </div>

            {/* Address */}
            <div className="flex items-start">
              <div className="w-12 h-12 flex items-center justify-center bg-white/15 rounded-full mr-5 flex-shrink-0">
                <GoLocation className="text-[#55d286] text-2xl" />
              </div>

              <div>
                <p className="text-sm text-purple-100 mb-1">Office Address</p>

                <p className="text-lg leading-7">
                  No. 44B Lumac Street, Satellite Town, Lagos, Nigeria
                </p>
              </div>
            </div>

            {/* TikTok */}
            <div className="flex items-center">
              <div className="w-12 h-12 flex items-center justify-center bg-white/15 rounded-full mr-5 flex-shrink-0">
                <FaTiktok className="text-[#55d286] text-xl" />
              </div>

              <div className="min-w-0">
                <p className="text-sm text-purple-100 mb-1">TikTok</p>

                <a
                  href="https://www.tiktok.com/@preorderwithcharex?_r=1&_t=ZN-98K5IDiaC7q"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg break-all hover:text-[#55d286] hover:underline transition-colors duration-300"
                >
                  @preorderwithcharex
                </a>
              </div>
            </div>

            {/* Facebook */}
            <div className="flex items-center">
              <div className="w-12 h-12 flex items-center justify-center bg-white/15 rounded-full mr-5 flex-shrink-0">
                <FaFacebookF className="text-[#55d286] text-xl" />
              </div>

              <div className="min-w-0">
                <p className="text-sm text-purple-100 mb-1">Facebook</p>

                <a
                  href="https://www.facebook.com/share/19NPYXYt7e/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg hover:text-[#55d286] hover:underline transition-colors duration-300"
                >
                  Follow CHAREX on Facebook
                </a>
              </div>
            </div>

            {/* WhatsApp */}
            <div className="flex items-center">
              <div className="w-12 h-12 flex items-center justify-center bg-white/15 rounded-full mr-5 flex-shrink-0">
                <FaWhatsapp className="text-[#55d286] text-2xl" />
              </div>

              <div>
                <p className="text-sm text-purple-100 mb-1">WhatsApp</p>

                <a
                  href="https://wa.me/2347064058684?text=Hello%20CHAREX%2C%20I%20would%20like%20to%20make%20an%20inquiry."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg font-semibold hover:text-[#55d286] hover:underline transition-colors duration-300"
                >
                  Chat with CHAREX on WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;